export default class Parameter {
    constructor(parameters) {

        this.ActiveDirectoryAllowedUserGroups = '';
        this.ActiveDirectoryAuthEnabled = false;
        this.AzureUseActiveDirectory = false;
        this.AzureMicrosoftGraphApiURL = '';
        this.ActiveDirectoryDomain = '';
        this.ActiveDirectoryServerPath = '';
        this.ClientID = '';
        this.CredentialID = '';
        this.ClientSecret = '';
        this.UserID = '';
        this.QuoVadisV2ApiURL = '';
        this.DashboardCacheEnabled = false;
        this.JobsExecutionTimeDocumentLifeCycle = '';
        this.JobsExecutionTimeDelegations = '';
        this.JobsExecutionTimeDataManagement = '';
        this.JobsExecutionTimeAlert = '';
        this.JobsExecutionTimeConnectedServices = '';
        this.SAMLEnabled = false;
        this.SAMLCertificate = '';
        this.SAMLEndpoint = '';
        this.SupportedFileFormats = '';
        this.WebApiURL = '';
        this.AIRecognitionAPIURL = '';
        this.AutorecognitionApiURL = '';
        this.WebsiteURL = '';
        this.MicrosoftEntraClientId = '';
        this.MicrosoftEntraClientSecret = '';
        this.MicrosoftEntraIDDefaultOrganizationId = '';
        this.OCRAPIURL = '';
        this.OneDriveMicrosoftGraphApiURL = '';
        this.OneDriveMicrosoftGraphClientID = '';
        this.OneDriveMicrosoftGraphClientSecret = '';
        this.GoogleDriveApiUrl = '';
        this.GoogleDriveClientId = '';
        this.GoogleDriveClientSecret = '';
        this.AIDefaultModel = '';

        if (parameters) {
            this.ActiveDirectoryAllowedUserGroups = parameters.find(p => p.name == 'ActiveDirectoryAllowedUserGroups').value;
            this.ActiveDirectoryAuthEnabled = parameters.find(p => p.name == 'ActiveDirectoryAuthEnabled').value == 'true';
            this.AzureUseActiveDirectory = parameters.find(p => p.name == 'AzureUseActiveDirectory').value == 'true';
            this.AzureMicrosoftGraphApiURL = parameters.find(p => p.name == 'AzureMicrosoftGraphApiURL').value;
            this.ActiveDirectoryDomain = parameters.find(p => p.name == 'ActiveDirectoryDomain').value;
            this.ActiveDirectoryServerPath = parameters.find(p => p.name == 'ActiveDirectoryServerPath').value;
            this.ClientID = parameters.find(p => p.name == 'ClientID').value;
            this.CredentialID = parameters.find(p => p.name == 'CredentialID').value;
            this.ClientSecret = parameters.find(p => p.name == 'ClientSecret').value;
            this.UserID = parameters.find(p => p.name == 'UserID').value;
            this.QuoVadisV2ApiURL = parameters.find(p => p.name == 'QuoVadisV2ApiURL').value;
            this.DashboardCacheEnabled = parameters.find(p => p.name == 'DashboardCacheEnabled').value == 'true';
            this.JobsExecutionTimeDocumentLifeCycle = parameters.find(p => p.name == 'JobsExecutionTimeDocumentLifeCycle').value;
            this.JobsExecutionTimeDelegations = parameters.find(p => p.name == 'JobsExecutionTimeDelegations').value;
            this.JobsExecutionTimeDataManagement = parameters.find(p => p.name == 'JobsExecutionTimeDataManagement').value;
            this.JobsExecutionTimeAlert = parameters.find(p => p.name == 'JobsExecutionTimeAlert').value;
            this.JobsExecutionTimeConnectedServices = parameters.find(p => p.name == 'JobsExecutionTimeConnectedServices').value;
            this.SAMLCertificate = parameters.find(p => p.name == 'SAMLCertificate').value;
            this.SAMLEndpoint = parameters.find(p => p.name == 'SAMLEndpoint').value;
            this.SAMLEnabled = (this.SAMLCertificate && this.SAMLEndpoint);
            this.SupportedFileFormats = parameters.find(p => p.name == 'SupportedFileFormats').value;
            this.WebApiURL = parameters.find(p => p.name == 'WebApiURL').value;
            this.AIRecognitionAPIURL = parameters.find(p => p.name == 'AIRecognitionAPIURL').value;
            this.AutorecognitionApiURL = parameters.find(p => p.name == 'AutorecognitionApiURL').value;
            this.WebsiteURL = parameters.find(p => p.name == 'WebsiteURL').value;
            this.MicrosoftEntraClientId = parameters.find(p => p.name == 'MicrosoftEntraClientId').value;
            this.MicrosoftEntraClientSecret = parameters.find(p => p.name == 'MicrosoftEntraClientSecret').value;
            this.MicrosoftEntraIDDefaultOrganizationId = parameters.find(p => p.name == 'MicrosoftEntraIDDefaultOrganizationId').value;
            this.OCRAPIURL = parameters.find(p => p.name == 'OCRAPIURL').value;
            this.OneDriveMicrosoftGraphApiURL = parameters.find(p => p.name == 'OneDriveMicrosoftGraphApiURL').value;
            this.OneDriveMicrosoftGraphClientID = parameters.find(p => p.name == 'OneDriveMicrosoftGraphClientID').value;
            this.OneDriveMicrosoftGraphClientSecret = parameters.find(p => p.name == 'OneDriveMicrosoftGraphClientSecret').value;
            this.GoogleDriveApiUrl = parameters.find(p => p.name == 'GoogleDriveApiUrl').value;
            this.GoogleDriveClientId = parameters.find(p => p.name == 'GoogleDriveClientId').value;
            this.GoogleDriveClientSecret = parameters.find(p => p.name == 'GoogleDriveClientSecret').value;
            this.AIDefaultModel = parameters.find(p => p.name == 'AIDefaultModel').value;
        }
    }

    toDto() {
        var parameters = [];
        parameters.push({ Name: 'ActiveDirectoryAllowedUserGroups', Value: this.ActiveDirectoryAllowedUserGroups });
        parameters.push({ Name: 'ActiveDirectoryAuthEnabled', Value: this.ActiveDirectoryAuthEnabled ? 'true' : 'false' });
        parameters.push({ Name: 'AzureUseActiveDirectory', Value: this.AzureUseActiveDirectory ? 'true' : 'false' });
        parameters.push({ Name: 'AzureMicrosoftGraphApiURL', Value: this.AzureMicrosoftGraphApiURL });
        parameters.push({ Name: 'ActiveDirectoryDomain', Value: this.ActiveDirectoryDomain });
        parameters.push({ Name: 'ActiveDirectoryServerPath', Value: this.ActiveDirectoryServerPath });
        parameters.push({ Name: 'ClientID', Value: this.ClientID });
        parameters.push({ Name: 'CredentialID', Value: this.CredentialID });
        parameters.push({ Name: 'ClientSecret', Value: this.ClientSecret });
        parameters.push({ Name: 'UserID', Value: this.UserID });
        parameters.push({ Name: 'QuoVadisV2ApiURL', Value: this.QuoVadisV2ApiURL });
        parameters.push({ Name: 'DashboardCacheEnabled', Value: this.DashboardCacheEnabled });
        parameters.push({ Name: 'JobsExecutionTimeDocumentLifeCycle', Value: this.JobsExecutionTimeDocumentLifeCycle });
        parameters.push({ Name: 'JobsExecutionTimeDelegations', Value: this.JobsExecutionTimeDelegations });
        parameters.push({ Name: 'JobsExecutionTimeDataManagement', Value: this.JobsExecutionTimeDataManagement });
        parameters.push({ Name: 'JobsExecutionTimeAlert', Value: this.JobsExecutionTimeAlert });
        parameters.push({ Name: 'JobsExecutionTimeConnectedServices', Value: this.JobsExecutionTimeConnectedServices });
        parameters.push({ Name: 'SAMLCertificate', Value: this.SAMLEnabled ? this.SAMLCertificate : '' });
        parameters.push({ Name: 'SAMLEndpoint', Value: this.SAMLEnabled ? this.SAMLEndpoint : '' });
        parameters.push({ Name: 'SupportedFileFormats', Value: this.SupportedFileFormats });
        parameters.push({ Name: 'WebApiURL', Value: this.WebApiURL });
        parameters.push({ Name: 'AIRecognitionAPIURL', Value: this.AIRecognitionAPIURL });
        parameters.push({ Name: 'AutorecognitionApiURL', Value: this.AutorecognitionApiURL });
        parameters.push({ Name: 'WebsiteURL', Value: this.WebsiteURL });
        parameters.push({ Name: 'MicrosoftEntraClientId', Value: this.MicrosoftEntraClientId });
        parameters.push({ Name: 'MicrosoftEntraClientSecret', Value: this.MicrosoftEntraClientSecret });
        parameters.push({ Name: 'MicrosoftEntraIDDefaultOrganizationId', Value: this.MicrosoftEntraIDDefaultOrganizationId });
        parameters.push({ Name: 'OCRAPIURL', Value: this.OCRAPIURL });
        parameters.push({ Name: 'OneDriveMicrosoftGraphApiURL', Value: this.OneDriveMicrosoftGraphApiURL });
        parameters.push({ Name: 'OneDriveMicrosoftGraphClientID', Value: this.OneDriveMicrosoftGraphClientID });
        parameters.push({ Name: 'OneDriveMicrosoftGraphClientSecret', Value: this.OneDriveMicrosoftGraphClientSecret });
        parameters.push({ Name: 'GoogleDriveApiUrl', Value: this.GoogleDriveApiUrl });
        parameters.push({ Name: 'GoogleDriveClientId', Value: this.GoogleDriveClientId });
        parameters.push({ Name: 'GoogleDriveClientSecret', Value: this.GoogleDriveClientSecret });
        parameters.push({ Name: 'AIDefaultModel', Value: this.AIDefaultModel });
        return parameters;
    }
}
